export enum CongratulationType {
  Normal = 'Normal',
  Cash = 'Cash',
  BankTransfer = 'BankTransfer',
  BackOfficeIssue = 'BackOfficeIssue',
}
